import { Event, MediaAspectRatio } from "@markit/common.types";
import { CSSProperties, useMemo } from "react";
import { Icon } from "@iconify/react";
import { Colors } from "../../../../utils/colors";
import { DropdownMenu, DropdownMenuItem } from "../../../DropdownMenu";

type MediaAspectRatioDropdownProps = {
  productData: Event;
  setProductData: (productData: Event) => void;
  containerStyle?: CSSProperties;
};

// Helper component for displaying a dropdown for the aspect ratio of a media
const MediaAspectRatioDropdown = (props: MediaAspectRatioDropdownProps) => {
  const { productData, setProductData, containerStyle } = props;

  const styles = {
    overlayButton: {
      backgroundColor: Colors.WHITE1,
      border: `0.5px solid ${Colors.GRAY2}`,
      borderRadius: 8,
      height: 35,
      width: 35,
      cursor: "pointer",
      ...containerStyle,
    },
  };

  const aspectRatioItems: DropdownMenuItem[] = useMemo(
    () => [
      ...Object.values(MediaAspectRatio)
        .filter((ratio) => ratio !== MediaAspectRatio.NONE)
        .map((ratio) => {
          return {
            title: ratio,
            key: ratio,
            icon:
              productData.mediaAspectRatio === ratio
                ? "ion:checkmark"
                : undefined,
            onPress: () =>
              setProductData?.({ ...productData, mediaAspectRatio: ratio }),
          };
        }),
    ],
    [productData, setProductData]
  );

  return (
    <DropdownMenu
      dropdownItems={aspectRatioItems}
      trigger={["click"]}
      placement="bottomRight"
      altWidth={150}
    >
      <div
        className="Centering"
        style={{ ...styles.overlayButton }}
        title="Aspect Ratio"
      >
        <Icon
          icon="material-symbols:aspect-ratio-outline"
          height={16}
          color={Colors.BLACK}
        />
      </div>
    </DropdownMenu>
  );
};

export default MediaAspectRatioDropdown;
